const getArrayLastItem = array => [...array].reverse()[0];

export default getArrayLastItem;
